/** @jsx jsx */
import { PureSection } from '@core';
import { jsx } from '@themed';
import React from 'react';

import { AnnounceTransformToAOE } from './AnnounceTransformToAOE';
import { styles } from './index.styles';

export const LandingPage = () => {
  return (
    <React.Fragment>
      <PureSection sx={{ ...styles.init.section, backgroundColor: 'primary' }}>
        <AnnounceTransformToAOE />
      </PureSection>
    </React.Fragment>
  );
};
